import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#8DC7E9' : props.fill;
  const width = !size && !props.width ? 115 : props.width;
  const height = !size && !props.height ? 28 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 115 28"
      >
        <defs>
          <filter colorInterpolationFilters="auto" id="a">
            <feColorMatrix
              in="SourceGraphic"
              values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(33.723508 5.273548)" filter="url(#a)">
            <path
              d="M78.874125 2.7825v.525H79.245c.274125 0 .39375-.09.39375-.2625 0-.21-.17625-.25875-.415875-.25875h-.34875V2.7825zm.37875.7575h-.37875v.6375h-.240375V2.53875h.495375c.475875 0 .768375.075.768375.49875 0 .18375-.097125.36-.3075.44625l.375.6975h-.277125l-.34125-.64125h-.09375zm1.259625-.13125c0-.795-.55125-1.3275-1.293375-1.3275-.727875 0-1.2975.5325-1.2975 1.3275 0 .7875.569625 1.32375 1.2975 1.32375.73875 0 1.293375-.53625 1.293375-1.32375zm.25125 0c0 .91875-.69375 1.545-1.544625 1.545-.85875 0-1.549125-.62625-1.549125-1.545S78.364125 1.86 79.219125 1.86c.850875 0 1.544625.63 1.544625 1.54875zm-7.747125-1.83v2.895h2.535v1.29h-2.535V13.995c0 1.67625.04875 2.01 1.77 2.01h.765v1.33875h-1.21875c-2.295 0-2.824125-.525-2.824125-3.06375V5.76375h-2.129625v-1.29h2.129625v-2.895h1.507875zm-9.64125 2.6775c3.0375 0 4.33125 1.81875 4.33125 4.97625v8.11125h-1.485v-7.7025c0-2.415-.6225-4.0425-3.229125-4.0425-2.223375 0-3.899625 1.8675-3.899625 4.59375v7.15125H57.6075v-12.87h1.485375V6.6525C59.715 5.43 60.9825 4.25625 63.375375 4.25625zM53.396625 9.975c0-2.17875-1.556625-4.37625-4.14-4.37625-2.3925 0-4.11375 1.53-4.425 4.37625h8.565zm-4.11375-5.71875C52.92 4.25625 55.215 7.32 55.02375 11.336625H44.782875c.04875 3.108375 2.009625 4.95375 4.6425 4.95375 2.009625 0 3.42-1.027875 3.9225-2.7975h1.555875C54.281625 16.1475 52.15125 17.655 49.327875 17.655c-3.78 0-6.075-2.70375-6.075-6.6975 0-4.16625 2.587125-6.70125 6.03-6.70125zm-8.4225.2175h1.600875l-4.78125 12.87h-1.43625l-4.927125-12.87H32.9925l3.994125 10.815 3.87375-10.815zm-12.274125 6.9825v-.6225c-5.238375.57375-7.488375 1.2675-7.488375 3.2775 0 1.365 1.245 2.2237586 2.943375 2.2237586 2.3925.0037414 4.545-1.2150086 4.545-4.8787586zM23.707875 17.655c-2.3925 0-4.260375-1.3875-4.260375-3.5175 0-2.9175 2.8725-3.99375 9.067875-4.61625V9.0675c0-2.9175-1.721625-3.56625-3.58875-3.56625-2.17875 0-3.49125 1.21875-3.61125 2.895H19.75875c.334125-2.535 2.392875-4.21125 5.265-4.21125 2.98875 0 4.976625 1.245 4.976625 5.07 0 1.77-.022875 2.94375-.022875 3.97125 0 1.45875.071625 2.72625.1425 4.11375h-1.507125l-.071625-1.96125c-.84 1.365-2.440875 2.27625-4.833375 2.27625zM1.60125 1.53v15.81375H0V0h2.584125l5.74125 15.525L14.044125 0h2.56125v17.34375h-1.60125V1.53l-5.89125 15.81375H7.485L1.60125 1.53z"
              fill="#353C46"
            />
          </g>
          <path
            d="M0 2v24h8.4975L1.35 18.597125l3.78-3.648375 4.395 4.5525L24 5.025875V2H0zm10.45125 24H24V12.45125L10.45125 26z"
            fill="#8DC7E9"
          />
        </g>
      </svg>
    </span>
  );
};

export default SvgIcon;
